import $ from 'cash-dom'
import { createAnalyticsGroup } from 'js/lib/analytics'

const track = createAnalyticsGroup('donation-button')

$('.js-c-donate-button').on('click', function(event) {
  const label = event.target.dataset ? event.target.dataset.source : undefined
  track('click', label)
})
